import { c as _c } from "react/compiler-runtime";
import { BreadcrumbsData, PrimaryButton, Tooltip } from '@systemeio/ui';
import { BLOGS_API } from 'modules/blogs/api/blog-api';
import BlogCategories from 'modules/blogs/components/blog-categories';
import BlogPages from 'modules/blogs/components/blog-pages';
import BlogPosts from 'modules/blogs/components/blog-posts';
import BlogSettings from 'modules/blogs/components/blog-settings';
import { BlogLoco } from 'modules/blogs/constants/blog-loco';
import { BlogSectionsEnum, BlogSectionsTitleEnum } from 'modules/blogs/enums/blog-sections-enum';
import { useBlog } from 'modules/blogs/hooks/use-blog';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { PageTab } from 'shared/components/page-tab/page-tab';
import { PageTabGroup } from 'shared/components/page-tab/page-tab-group';
import { PageTabList } from 'shared/components/page-tab/page-tab-list';
import { PageTabPanel } from 'shared/components/page-tab/page-tab-panel';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
import { BlogLayoutIcon, EyeIcon } from '@systemeio/ui/icons';
const BlogEdit: NextPage = () => {
  const $ = _c(109);
  const router = useRouter();
  const {
    t
  } = useLocoTranslation();
  const {
    blogId,
    section
  } = router.query;
  const t0 = `${BLOGS_API}/${blogId}`;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      constantApi: [`${BLOGS_API}/list`, t0],
      api: BLOGS_API
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const updateData = useUpdateData(t1);
  const t2 = blogId as string;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      id: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    blog,
    blogMutate
  } = useBlog(t3);
  let t4;
  if ($[4] !== t) {
    t4 = t("dashboard.blog.title_plural");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = {
      caption: t4,
      href: "/blogs",
      isStatic: true
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = blog?.name || "";
  let t7;
  if ($[8] !== t6) {
    t7 = {
      caption: t6
    };
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = BlogSectionsTitleEnum[section as keyof typeof BlogSectionsTitleEnum];
  let t9;
  if ($[10] !== t || $[11] !== t8) {
    t9 = t(t8);
    $[10] = t;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = {
      caption: t9,
      isStatic: true
    };
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t5 || $[17] !== t7) {
    t11 = [t5, t7, t10];
    $[15] = t10;
    $[16] = t5;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const breadcrumbsData = t11;
  const t12 = !blog;
  let t13;
  if ($[19] !== breadcrumbsData || $[20] !== t12) {
    t13 = <BreadcrumbsDashboard data={breadcrumbsData} isFetching={t12} />;
    $[19] = breadcrumbsData;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t) {
    t14 = t("dashboard.blog.blog_layout_description");
    $[22] = t;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== blog) {
    t15 = blog && getPageEditorUrl(blog.layoutPage.id);
    $[24] = blog;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = !blog;
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <BlogLayoutIcon />;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t) {
    t18 = t("dashboard.blog.blog_layout");
    $[27] = t;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t18) {
    t19 = <span className="hidden lg:flex">{t18}</span>;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t15 || $[32] !== t16 || $[33] !== t19) {
    t20 = <PrimaryButton as={LinkWithoutPrefetch} href={t15} aria-disabled={t16}>{t17}{t19}</PrimaryButton>;
    $[31] = t15;
    $[32] = t16;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t14 || $[36] !== t20) {
    t21 = <Tooltip mode="hover" label={t14}>{t20}</Tooltip>;
    $[35] = t14;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  const t22 = !blog;
  const t23 = `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${blog?.domain.domainName}/${blog?.path}`;
  let t24;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <EyeIcon className="fill-background-secondary" />;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t) {
    t25 = t("dashboard.blog.view_blog");
    $[39] = t;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== t25) {
    t26 = <span className="hidden lg:flex">{t25}</span>;
    $[41] = t25;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== t22 || $[44] !== t23 || $[45] !== t26) {
    t27 = <PrimaryButton as={LinkWithoutPrefetch} target="_blank" aria-disabled={t22} href={t23}>{t24}{t26}</PrimaryButton>;
    $[43] = t22;
    $[44] = t23;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== blog || $[48] !== blogMutate || $[49] !== updateData) {
    t28 = <BlogSettings blog={blog} updateData={updateData} blogMutate={blogMutate} />;
    $[47] = blog;
    $[48] = blogMutate;
    $[49] = updateData;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== t21 || $[52] !== t27 || $[53] !== t28) {
    t29 = <div className="flex gap-5 whitespace-nowrap">{t21}{t27}{t28}</div>;
    $[51] = t21;
    $[52] = t27;
    $[53] = t28;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] !== t13 || $[56] !== t29) {
    t30 = <div className="flex items-center justify-between gap-5">{t13}{t29}</div>;
    $[55] = t13;
    $[56] = t29;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  const t31 = Object.values(BlogSectionsEnum).findIndex(el => el === section);
  let t32;
  if ($[58] !== blog || $[59] !== section || $[60] !== t) {
    t32 = section === BlogSectionsEnum.posts && <Tooltip popoverClassName="max-w-[350px]" className="pr-4 sm:pr-0" mode="hover" label={t("dashboard.blog.posts.post_layout_description")}><PrimaryButton as={LinkWithoutPrefetch} href={blog && getPageEditorUrl(blog.postLayoutPage.id)} aria-disabled={!blog}><BlogLayoutIcon /><span className="hidden lg:flex">{t("dashboard.blog.posts.post_layout")}</span></PrimaryButton></Tooltip>;
    $[58] = blog;
    $[59] = section;
    $[60] = t;
    $[61] = t32;
  } else {
    t32 = $[61];
  }
  let t33;
  if ($[62] !== blogId || $[63] !== router) {
    t33 = () => router.push({
      query: {
        blogId,
        section: BlogSectionsEnum.posts
      }
    });
    $[62] = blogId;
    $[63] = router;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] !== t) {
    t34 = t("dashboard.blog.posts.title_plural");
    $[65] = t;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  let t35;
  if ($[67] !== t33 || $[68] !== t34) {
    t35 = <PageTab onClick={t33}>{t34}</PageTab>;
    $[67] = t33;
    $[68] = t34;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== blogId || $[71] !== router) {
    t36 = () => router.push({
      query: {
        blogId,
        section: BlogSectionsEnum.pages
      }
    });
    $[70] = blogId;
    $[71] = router;
    $[72] = t36;
  } else {
    t36 = $[72];
  }
  let t37;
  if ($[73] !== t) {
    t37 = t("dashboard.blog.pages.title_plural");
    $[73] = t;
    $[74] = t37;
  } else {
    t37 = $[74];
  }
  let t38;
  if ($[75] !== t36 || $[76] !== t37) {
    t38 = <PageTab onClick={t36}>{t37}</PageTab>;
    $[75] = t36;
    $[76] = t37;
    $[77] = t38;
  } else {
    t38 = $[77];
  }
  let t39;
  if ($[78] !== blogId || $[79] !== router) {
    t39 = () => router.push({
      query: {
        blogId,
        section: BlogSectionsEnum.categories
      }
    });
    $[78] = blogId;
    $[79] = router;
    $[80] = t39;
  } else {
    t39 = $[80];
  }
  let t40;
  if ($[81] !== t) {
    t40 = t("dashboard.blog.categories.title_plural");
    $[81] = t;
    $[82] = t40;
  } else {
    t40 = $[82];
  }
  let t41;
  if ($[83] !== t39 || $[84] !== t40) {
    t41 = <PageTab onClick={t39}>{t40}</PageTab>;
    $[83] = t39;
    $[84] = t40;
    $[85] = t41;
  } else {
    t41 = $[85];
  }
  let t42;
  if ($[86] !== t32 || $[87] !== t35 || $[88] !== t38 || $[89] !== t41) {
    t42 = <PageTabList buttonBar={t32}>{t35}{t38}{t41}</PageTabList>;
    $[86] = t32;
    $[87] = t35;
    $[88] = t38;
    $[89] = t41;
    $[90] = t42;
  } else {
    t42 = $[90];
  }
  const t43 = blogId as string;
  let t44;
  if ($[91] !== blog || $[92] !== t43) {
    t44 = <PageTabPanel><BlogPosts blogId={t43} blog={blog} /></PageTabPanel>;
    $[91] = blog;
    $[92] = t43;
    $[93] = t44;
  } else {
    t44 = $[93];
  }
  const t45 = blogId as string;
  let t46;
  if ($[94] !== blog || $[95] !== t45) {
    t46 = <PageTabPanel><BlogPages blogId={t45} blog={blog} /></PageTabPanel>;
    $[94] = blog;
    $[95] = t45;
    $[96] = t46;
  } else {
    t46 = $[96];
  }
  const t47 = blogId as string;
  let t48;
  if ($[97] !== blog || $[98] !== t47) {
    t48 = <PageTabPanel><BlogCategories blogId={t47} blog={blog} /></PageTabPanel>;
    $[97] = blog;
    $[98] = t47;
    $[99] = t48;
  } else {
    t48 = $[99];
  }
  let t49;
  if ($[100] !== t31 || $[101] !== t42 || $[102] !== t44 || $[103] !== t46 || $[104] !== t48) {
    t49 = <PageTabGroup selectedIndex={t31}>{t42}{t44}{t46}{t48}</PageTabGroup>;
    $[100] = t31;
    $[101] = t42;
    $[102] = t44;
    $[103] = t46;
    $[104] = t48;
    $[105] = t49;
  } else {
    t49 = $[105];
  }
  let t50;
  if ($[106] !== t30 || $[107] !== t49) {
    t50 = <><div className="flex flex-col gap-5">{t30}{t49}</div></>;
    $[106] = t30;
    $[107] = t49;
    $[108] = t50;
  } else {
    t50 = $[108];
  }
  return t50;
};
export const getServerSideProps = getBaseServerSideProps(BlogLoco, 'header.top_menu.blogs');
export default BlogEdit;